import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  // private messageSource = new Subject<string>();
  missingDates = 'No dates selected';
  missingName = 'Missing Name';
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  private configSuccess: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    panelClass: ['snackbar-success'],
  };

  private configError: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    panelClass: ['snackbar-error'],
  };

  private configWarn: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    panelClass: ['snackbar-warning'],
  };

  /** Bootstrap */
  private errorMessageSource = new Subject();

  private messageSource = new Subject();
  messageSource$ = this.messageSource.asObservable();

  constructor(
    private _snackBar: MatSnackBar,
    private logger: NGXLogger
  ) {
  }

  snackbarSuccess(message, action?) {
    this._snackBar.open(message, 'close', this.configSuccess);
  }

  snackbarError(message, action?) {
    this._snackBar.open(message, 'close', this.configError);
  }

  alert(message: string) {
    const messageSource = new Subject<string>();
    this.messageSource.next(message);
    this._snackBar.open(message, 'Close', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000
    });
  }

  /** Bootstrap */

  message(msg: string, type?, duration?) {
    if (type === undefined) {
      type = 'danger';
    }
    const messageSource = new Subject<string>();
    if (msg === 'dates') {
      this.logger.log('No date selected');
    }
    messageSource.next(msg);
    this.messageSource.next({msg, type});
  }

  errorMessage(err, type?) {
    if (err.status === 400) {
      return err.statusText;
    } else {
      return err.error.message;
    }
  }
}
